import { render } from "./AlzataTableColumnHeader.vue?vue&type=template&id=53e99844"
import script from "./AlzataTableColumnHeader.vue?vue&type=script&lang=js"
export * from "./AlzataTableColumnHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__